'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.partsBinder = void 0;
function reduceBindingsObj(bindingsObj) {
    var keys = Object.keys(bindingsObj);
    return keys.reduce(function (acc, key) {
        var bindsTo = bindingsObj[key];
        if (typeof bindsTo === 'function') {
            var bindsToResult = bindsTo();
            if (!bindsToResult) {
                return acc;
            }
            if (acc === '') {
                return "" + key;
            }
            return acc + " " + key;
        }
        if (bindingsObj[key]) {
            if (acc === '') {
                return key;
            }
            return acc + " " + key;
        }
        return acc;
    }, '');
}
/**
 * Simulates class and style attributes vue bindings
 * intended to be used for part attributes in templates
 *
 * @param prefix string
 * @param bindings Record<string, boolean | (() => boolean)>
 * @returns string
 */
function partsBinder(prefix, bindings) {
    if (!bindings) {
        return prefix;
    }
    var _bindings = bindings;
    var _prefix = '';
    if (typeof prefix === 'object') {
        _bindings = prefix;
    }
    if (typeof prefix === 'string') {
        _prefix = prefix;
    }
    if (typeof _bindings === 'string') {
        return _prefix + " " + _bindings;
    }
    if (Array.isArray(_bindings)) {
        var parts = _bindings.map(function (value) {
            if (typeof value === 'string') {
                return value;
            }
            if (typeof value === 'object') {
                return reduceBindingsObj(value);
            }
            return '';
        });
        var result = [_prefix];
        return result.concat(parts).join(' ');
    }
    var suffix = reduceBindingsObj(_bindings);
    return "" + _prefix + (suffix === '' ? '' : ' ' + suffix);
}
exports.partsBinder = partsBinder;
